import { render, staticRenderFns } from "./CajaChicaPage.vue?vue&type=template&id=060ef01c"
import script from "./CajaChicaPage.js?vue&type=script&lang=js&external"
export * from "./CajaChicaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports